export const useInputImageRenderer = (inputEl, callback) => {
  const inputImageRenderer = () => {
    const file = inputEl.value.files[0]
    const reader = new FileReader()

    reader.addEventListener(
      'load',
      () => {
        callback(reader.result)
      },
      false,
    )

    if (file) {
      reader.readAsDataURL(file)
    }
  }
  return {
    inputImageRenderer,
  }
}

export const useFileToBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader()

  reader.onloadend = () => {
    resolve(reader.result)
  }

  if (file) {
    reader.readAsDataURL(file)
  } else {
    reject(new Error('El File es requerido'))
  }
})

export const _ = null
